// typings

import { create } from "zustand";

import { IManageClientState } from "@/store-zustand/manage-client/index";

// criação da store com Zustand (Clientes)
export const useStoreZustandManageClient = create<IManageClientState>((set) => ({
  // estados
  isLoading: false,
  isModalCreateClient: false,
  isLoadingPage: false,
  clients: [],
  paginations: [1],
  contatos: [],
  clienteEditar: null,
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 0,
  userIdCliente: null,
  isModalAddCredit: false,
  isModalExclude: false,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setClients: (clients) => set({ clients }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setContatos: (contatos) => set({ contatos }),
  setClienteEditar: (clienteEditar) => set({ clienteEditar }),
  setIsModalCreateClient: (isModalCreateClient) => set({ isModalCreateClient }),
  setLastPage: (lastPage) => set({ lastPage }),
  setPaginations: (paginations) => set({ paginations }),
  setUserIdCliente: (userIdCliente) => set({ userIdCliente }),
  setIsModalAddCredit: (isModalAddCredit) => set({ isModalAddCredit }),
  setIsModalExclude: (isModalExclude) => set({ isModalExclude }),
}));
